import { Outlet } from "react-router";
import { FilterProvider } from "../../../context/FilterProvider";

const DetailedCompletionsFilter = () => {
    return (
        <FilterProvider>
            <Outlet />
        </FilterProvider>
    );
}

export default DetailedCompletionsFilter;